import React from 'react';
import { GenericListPage } from '../../../components/generic';
import { useTaskStatuss, TaskStatus } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<TaskStatus>
      useData={useTaskStatuss}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;
